import React from "react"
import styled from "@emotion/styled"
import { Box, Flex } from "@rebass/grid/emotion"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import { ButtonWild } from "@nutrafol/nutrafol-ui-kit/dist/ButtonWild"
import ComparisonTable from "../products/womens/comparisontable"

const ComparisonModalWrap = styled.div`
  margin: 64px auto;
  @media (min-width: 1024px) {
    width: calc(100% - 16px);
    max-width: 1488px;
  }
  #CloseWrapper {
    display: none;
  }
  
  #ModalBody {
    padding: 0;
    overflow: auto;
  }
  
  .before-footer {
    .btn {
      width: 100%;
      text-transform: none;
    }
  }
  
  .comparison-table {
    padding-bottom: 0;
  }
  #comparison {
    .comparison-table {
      margin-left: auto;
      margin-right: auto;
    }
  }

`

const ComparisonModal = (props) => {

  const { products, comparisonColumnsArr = [], handleChangeProduct, hideCompareModal } = props
  const items =  Object.keys(products).map(key => {
    return  {...products[key], ...{key}}
  })
  const men = items.find(item => item.key === "Men")
  const menIndex = items.indexOf(men)
  let itemsFiltered = items.filter(product => product.key !== 'Men')
  
  const comparison = {
    comparisonColumnsArr
  }

  const onSelect = (idx, fireEvent = false) => {
    fireEvent && segmentEvent("Marketing CTA Clicked", {})
    handleChangeProduct(items[idx].key)
    hideCompareModal()
  }
  
  const  beforeFooter = ()=>{
    return men ? (
      <Flex
        width={[1]}
        alignItems="center"
        flexWrap="wrap"
        mt={16}
        pb={[16]}
        py={["8px", "8px", "16px"]}
        pl={["4px", "4px", "16px"]}
        pr={["16px"]}
        className="rounded before-footer bg-master-secondary-alt"
      >
        <Box width={[65, 65, 135]}>
          <img src={`${men.img}&w=182`} alt="" />
        </Box>
        <Box flex="1">
          <TextElementMen
            text={`Nutrafol Men`}
            element="p"
            className="title--small text-master-secondary-default"
          />
          <TextElementMen
            text={`For men 18+ experiencing signs of hair thinning and less scalp coverage.`}
            element="p"
            className="body--small text-master-base-black"
          />
          <ButtonWild
            arrowRight
            textLink
            label="Select Nutrafol Men"
            onClick={() => onSelect(menIndex, true)}
            className="hide-md-up"
          />
        </Box>
        <Box width={[0, 0, 256]}>
          <ButtonWild
            primary
            label="Select"
            onClick={() => onSelect(menIndex, true)}
            className="show-md-up btn"
          />
        </Box>
      </Flex>
    ) : null 
  }
  
  return (
    <ComparisonModalWrap>
      <ComparisonTable beforeFooter={beforeFooter} scrollToRef={onSelect} items={itemsFiltered} comparisonColumnsArr={comparisonColumnsArr} comparison={comparison} />
    </ComparisonModalWrap>
  
  )
}

export default ComparisonModal